import gql from 'graphql-tag'

export const getCandidateCarrierProducts = gql`
  query($paging: PagingQuery, $filter: CarrierProductsFilter!) {
    getCarrierProducts(
      filter: $filter,
      paging: $paging
    ) {
      carrierProducts {
        id
        name
      }
    }
  }
`

export const getCarrierProductCommissions = gql`
  query($carrierProductId: Int!) {
    getCarrierProductCommissions(
      carrierProductId: $carrierProductId
    ) {
      id
      carrierId
      carrierName
      gaId
      gaName
      commissionName
      commission
    }
  }
`

export const getCarrierProducts = gql`
  query($paging: PagingQuery, $order: CarrierProductsOrder, $filter: CarrierProductsFilter!) {
    getCarrierProducts(
      filter: $filter,
      order: $order,
      paging: $paging,
    ) {
      carrierProducts {
        id
        name
        notes
        toBeReviewed
        naicCode
        lineOfBusinessCode
        downloads
        policyDocumentsDelivery
        endorsementDocumentDelivery
        quoteVia
        agencyBill
        bindIssueVia
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        carriers{
          id
          name
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCarrierProduct = gql`
  query($carrierProductId: Int!) {
    getCarrierProduct(
      carrierProductId: $carrierProductId
    ) {
      id
      name
      notes
      toBeReviewed
      naicCode
      lineOfBusinessCode
      downloads
      policyDocumentsDelivery
      endorsementDocumentDelivery
      quoteVia
      agencyBill
      bindIssueVia
      createdAt
      updatedAt
      commissions {
        id
        gaId
        gaName
        carrierId
        carrierName
        commissionName
        commission
      }
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      carriers {
        id
        name
      }
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        caseId
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      policies {
        id
        policyName
        status
        closeDate
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        closed
        createdAt
        updatedAt
        productCommissionOverride
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        caseId
        payerType
        bindDate
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
      }
    }
  }
`

export const newCarrierProduct = gql`
  mutation($carrierProductInput: CarrierProductInput!) {
    newCarrierProduct(
      carrierProductInput: $carrierProductInput
    ) {
      id
    }
  }
`

export const editCarrierProduct = gql`
  mutation($carrierProductId: Int!, $carrierProductInput: CarrierProductInput!) {
    editCarrierProduct(
      carrierProductId: $carrierProductId,
      carrierProductInput: $carrierProductInput
    ) {
      id
    }
  }
`

export const deleteCarrierProduct = gql`
  mutation($carrierProductId: Int!) {
    deleteCarrierProduct(
      carrierProductId: $carrierProductId
    )
  }
`

export const newCarrierProductCommission = gql`
  mutation($input: CarrierProductCommissionInput!, $productId: Int!) {
    newCarrierProductCommission(input: $input, productId: $productId) {
      id
    }
  }
`

export const editCarrierProductCommission = gql`
  mutation($commissionId: Int!, $input: CarrierProductCommissionInput!) {
    editCarrierProductCommission(commissionId: $commissionId, input: $input) {
      id
    }
  }
`

export const deleteCarrierProductCommission = gql`
  mutation($commissionId: Int!) {
    deleteCarrierProductCommission(
      commissionId: $commissionId
    )
  }
`
